import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/Global-Services/common.service';
import { Router } from '@angular/router';
import { GlobalVariable } from 'src/app/Variable/global-variable';
import { AppTokenHandler } from 'src/app/Global-Services/app-token-handler';
import { environment } from 'src/environments/environment';
import { AzureAuthService } from 'src/app/Global-Services/azure-auth.service';
import { catchError, Subject, takeUntil, throwError } from 'rxjs';
import { LoginService } from 'src/app/Global-Services/login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  standalone: false,
})
export class LoginComponent implements OnInit {
  LoaderStatus: boolean;
  token: any;
  private azure_token: string = '';
  private readonly _destroying$ = new Subject<void>();
  constructor(private gservice: CommonService, private router: Router, private gVariable: GlobalVariable,
    private appToken: AppTokenHandler,
    private _azureAuthService: AzureAuthService,
    private loginService: LoginService) { }

  ngOnInit() {

    // this.GetUserDetails('/INFTE/home');
    //   var account = this.msalService.getAccount();
    //   if (account) {
    //     const accessTokenRequest = {
    //         scopes: ["user.read"],
    //         account: account,
    //     };

    //   this.msalService.acquireTokenPopup(accessTokenRequest).then((res) => {
    //     console.log("acquireTokenPopup");
    //     this.token = res.accessToken;
    //     this.appToken.setAzureTokenLocalStorage(this.token);
    //         this.GetUserDetails('/INFTE/home');
    //   },)
    // }
    // Initialize the MSAL service first
    if (environment.hostingEnvironment == 'azure') {
      this.acquireAzureToken();
    } else {
      this.GetUserDetails('/INFTE/home');
    }
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }


  GetUserDetails(href: string) {
    //
    this.LoaderStatus = true;
    this.appToken.clearSessionToken();
    if (this.appToken.getSessionToken().length <= 0) {
      this.gservice.userAuthentication(href, "first");
    }
    //
    this.setGlobalVariableḍValue();
    // if (this.gVariable.User != null) {
    //   if (href === null || href === undefined || href === '') {
    //     this.router.navigate(['/INFTE/home']);
    //   } else {
    //     this.router.navigate([href]);
    //   }
    // } else {
    //   this.gservice.RedirectToErrorPage('1');
    // }
  }
  setGlobalVariableḍValue() {
    this.gVariable.userToken = sessionStorage.getItem('userToken');
    // this.gVariable.User = this.gservice.getUserDetails('first');
  }

  async acquireAzureToken() {
    this._azureAuthService.handleQueryParameters()
      .pipe(
        takeUntil(this._destroying$),
        catchError(error => {
          return throwError(() => error);
        })
      )
      .subscribe({
        next: (result: any) => {
          if (result) {
            this.azure_token = result;
            this.appToken.setAzureTokenLocalStorage(this.azure_token);
            this.loginService.getUserDetails();
          }
        }
      });
  }

}

